
import gql from 'graphql-tag';

// // prueba
export const sourceRezagados = gql`
query sourceRezagados($gwuuid: String, $time: Float) {
        sourceRezagados(gwuuid: $gwuuid, time: $time) 

}`

// Obtenemos los elementos que tienen el campo ping:

export const elemPing = gql`
query LMping{
  findLmPings {
    uuid
    host
    alive {
      lastEntrada {
        lastFecha
        lastValor
      }
      
      tiene {
        nombre
      }
    }
  }
}`

export const elemPing_back = gql`
query LMping{
  lmpings {
    uuid
    host
    alive {
      lastEntrada {
        lastFecha
        lastValor
      }
      tiene {
        nombre
      }
    }
  }
}`






// Obtenemos la estructura de los gateway raiz:
// Falta añadir algún campo pero tengo que mirarlos
// porque dan todos a null, algo hay mal calculado 
// posiblemente.
export const gatewaysRaiz = gql`
query gatewaysRaiz {
  gatewaysRaiz{
    lastSource {
      lastEntrada {
        lastFecha
      }
    }
    nombre
    uuid
    sourcesTotal
  }
  }
`

export const gatewaysRaiz_back = gql`
query gatewaysRaiz {
  gatewaysRaiz{
    nombre
    uuid
    sourcesTotal
    last {
      nombre
      lastEntrada  {
        last
      }
    }
  }
  }
`

// Obtenemos la estructura desde el gateway que estamos navegando
// export const dataField = gql`
// query Gateway($uuid: ID) {
//     Gateway(uuid: $uuid) {
//             uuid
//     nombre
//     topic
//     last
//     lastFecha
//     labels
//     gateways {
//       to {
//         uuid
//         Gateway {
//           last
//           lastFecha
//           uuid
//           nombre
//           topic
//           sources {
//             Source {
//               uuid
//               nombre
//               topic
//             }
//           }
//           labels
//         }
//       }
//     	from {
//         Gateway {
//           uuid
//           nombre
//           topic
//           sources {
//             Source {
//               uuid
//               nombre
//               topic
//             }
//           }
//           labels
//         }
//       }
//     }
// 		sources {
//       uuid
//       Source {
//         uuid
//         nombre
//         topic
//       }
//     }

//     }
// }`;


export const dataField = gql`
query Gateway($uuid: String) {
  findGateway(uuid: $uuid) {
    nombre
    topic
    labels
    gatewaysTo {
      uuid
      nombre
      topic
      sources {
        uuid
        uuid
        nombre
        topic
      }
    }
    sources {
      
      uuid
      nombre
      topic
      modelo
    }
  }
}`;


// Atributos de Label
export const atributosGateway = gql`
query Gateway($uuid: String) {
  findGateway(uuid: $uuid) {
    nombre
    topic
  }
}`;
export const atributosDispositivo = gql`
query Dispositivo($uuid: String) {
    findDispositivo(uuid: $uuid) {
      nombre
      descripcion
      nombreTecnico
    }
}`;
export const atributosLMPing = gql`
query LMPing($uuid: String) {
  findLmPing(uuid: $uuid) {
    host
    }
}`;
export const atributosMbBus = gql`
query MbBus($uuid: String) {
  findTcpMbBus(uuid: $uuid) {
      nombre
      path
      baudRate
      parity
      dataBits
      stopBits
      timeout
      wait
    }
}`;

export const atributosTcpBus = gql`
query TcpBus($uuid: String) {
  findTcpBus(uuid: $uuid) {
      ip
      mask
    }
}`;

export const atributosTcpDevice = gql`
query TcpDevice($uuid: String) {
  findTcpDevice(uuid: $uuid) {
      nombre
      host
    }
}`;

export const atributosMbRtuDevice = gql`
query MbRtuDevice($uuid: String) {
  findMbRtuDevice(uuid: $uuid) {
      nombre
      path
      baudRate
      parity
      dataBits
      stopBits
    }
}`;

export const updateDispositivo = gql`
mutation($uuid: String!, $nombre: String!, $descripcion: String, $nombreTecnico: String) {
  updateDispositivo(uuid: $uuid, nombre: $nombre, descripcion: $descripcion,nombreTecnico: $nombreTecnico) {
    uuid
    nombre
    descripcion
    nombreTecnico
  }
}`;

export const updateGateway = gql`
mutation($uuid: ID!, $nombre: String!, $topic: String) {
  UpdateGateway(uuid: $uuid, nombre: $nombre, topic: $topic) {
    uuid
    nombre
    topic
  }
}`;

export const updateLMping = gql`
mutation($uuid: ID!, $nombre: String!, $host: String) {
  UpdateLMping(uuid: $uuid, nombre: $nombre, host: $host) {
    uuid
    nombre
    host
  }
}`;

export const updateTcpBus = gql`
mutation($uuid: ID!, $nombre: String!, $Ip: String, $mask:String) {
  UpdateTcpBus(uuid: $uuid, nombre: $nombre, Ip: $Ip, mask: $mask) {
    uuid
    nombre
    Ip
    mask
  }
}`;

export const updateTcpDevice = gql`
mutation($uuid: ID!, $nombre: String!, $host: String) {
  UpdateTcpDevice(uuid: $uuid, nombre: $nombre, host: $host) {
    uuid
    nombre
    host
  }
}`;

export const updateMbBus = gql`
mutation($uuid: ID!, $nombre: String!, $path: String, $baudRate: Int, $parity:String,
  $dataBits: Int, $stopBits: Int, $timeout : Int, $wait: Int
  ) {
    UpdateMbBus(uuid: $uuid, nombre: $nombre, path: $path, baudRate: $baudRate, parity: $parity
      dataBits: $dataBits, stopBits: $stopBits, timeout: $timeout, wait: $wait) {
        uuid
        nombre
        path
        baudRate
        parity
        dataBits
        stopBits
        timeout
        wait
  }
}`;

export const updateMbDevice = gql`
mutation($uuid: ID!, $nombre: String!, $mbit: String) {
  UpdateMbDevice(uuid: $uuid, mbit: $mbit) {
    uuid
    mbid
  }
}`;

export const updateMbRtuDevice = gql`
mutation($uuid: ID!, $nombre: String!, $path: String, $baudRate: Int, $parity:String,
  $dataBits: Int, $stopBits: Int
  ) {
    UpdateMbBus(uuid: $uuid, nombre: $nombre, path: $path, baudRate: $baudRate, parity: $parity
      dataBits: $dataBits, stopBits: $stopBits) {
        uuid
        nombre
        path
        baudRate
        parity
        dataBits
        stopBits
  }
}`;
// Fin atributos Label

// Solo los gateways en el campo 'to'
// export const gatewaysTo = gql`
// query Gateway($uuid: ID) {
//     Gateway(uuid: $uuid) {
//         nombre
//         uuid
//         gateways {
//           to {
//             Gateway {
//               last
//               lastFecha
//               nombre
//               topic
//               uuid
//             }
//           }
//         }
//     }
// }`;

export const gatewaysTo = gql`
query Gateway($uuid: String) {
  findGateway(uuid:$uuid) {
    nombre
    uuid
    gatewaysTo {
          nombre
          topic
          uuid
          sourcesTotal
          lastSource {
            lastEntrada {
              lastFecha
              lastValor
            }
          }
    }
}
}`;



// Solo los gateways en el campo 'from'
export const gatewaysFrom = gql`
query Gateway($uuid: String) {
  findGateway(uuid: $uuid) {
    nombre
    uuid
    gatewaysFrom {        
          uuid
          nombre
    }
}
}`;


// Para extraer los sources y entradas
export const sources = gql`
query Gateway($uuid: String) {
  findGateway(uuid: $uuid) {
    sources {
      nombre
      topic
      uuid
      entradasConnection {
        edges {
          uuid
          topic
          last
          lastFecha
          lastValor
        }
      }
    }
  }
}`;


// Para obtener las entradas que más adelante se vincularán con un dato
export const entradas = gql`
query Source($uuid: String) {
    findSource(uuid: $uuid) {
      uuid
      nombre
      topic
      modelo
      MbDevice {
      uuid
      nombre
      descripcion
      readLimit
        MbRegister {
          address
          descripcion
          uuid
          }
        }
      labels
      entradasConnection {
        edges {
          uuid
          topic
          last
          lastFecha
          lastValor
          node {
            uuid
            esConnection {
              edges {
                node {
                  nombre
                  descripcion
                  nombreCode
                }
              }
            }
            tieneConnection {
              edges {
                node {
                  uuid
                  nombre
                  labels
                }
              }
            }
          }
        }
      }
    } 
}`




// Extraemos información sobre LMping!
export const LMping = gql`
query LMping($uuid: String) {
  findLmPing(uuid: $uuid) {
    uuid
    host
   labels
    alive {
      uuid
      lastFecha
      lastValor
      lastEntrada  {
        uuid
        lastFecha
        lastValor
        topic
      }
    }
  }
}
`







// Nodos con datos alarmados a ambos niveles :
export const mergeNodeAlarms = gql`
query mergeNodeAlarms($uuid: String) {
  nodosAlarmados(uuid: $uuid) {
    uuid
    datosAlarmados
    datosSilenciados
    datosConEntradas
    entradas {
      uuid
      alarmado
      silenciado
      __typename
    }
    lastEntrada {
      uuid
      topic
      dato {
        uuid
        lastFecha
        lastValor
        tiene {
          uuid
          nombre
        }
        entradas {
          topic
        }
        es {
          uuid
          nombre
          nombre_es
          nombre_en
          unidad
        }
        alarmado
        silenciado
      }
    }
  }
  entradasAlarmadasLink(uuid: $uuid) {
    uuid
    alarmado
    lastFecha
    lastValor
    silenciado
    es {
      uuid
      nombre
      nombre_es
      nombre_en
      unidad
    }
    tiene {
      uuid
      nombre
    }
  }
  datosAlarmados(uuid: $uuid) {
    uuid
    alarmado
    lastFecha
    lastValor
    silenciado
    es {
      uuid
      nombre
      nombre_es
      nombre_en
      unidad
    }
    tiene {
      uuid
      nombre
    }
  }
  nodosAlarmadosLink(uuid: $uuid) {
    uuid
    datosAlarmados
    datosSilenciados
    datosConEntradas
    entradas {
      uuid
      alarmado
      silenciado
      __typename
    }
    lastEntrada {
      uuid
      topic
      dato {
        uuid
        lastFecha
        lastValor
        es {
          uuid
          nombre
          nombre_es
          nombre_en
          unidad
        }
        tiene {
          uuid
          nombre
        }
        entradas {
          topic
        }
        alarmado
        silenciado
      }
    }
  
}
}`

export const mergeNodeAlarms_back = gql`
query mergeNodeAlarms($uuid: String) {
  nodosAlarmados(uuid: $uuid) {
    uuid
    datosAlarmados
    datosSilenciados
    entradasConnection {
      edges {
        lastFecha
        node {
          uuid
          alarmado
          silenciado
          lastFecha
          lastValor
          tiene {
            uuid
            nombre
          }
          entradas {
            uuid
            nombre
          }
        }
      }
    }
  }
  entradasAlarmadasLink(uuid: $uuid) {
    uuid
    alarmado
    lastFecha
    lastValor
    silenciado
    tiene {
      uuid
      nombre
    }
  }
  datosAlarmados(uuid: $uuid) {
    uuid
    alarmado
    lastFecha
    lastValor
    silenciado
    tiene {
      uuid
      nombre
    }
  }
  nodosAlarmadosLink(uuid: $uuid) {
    uuid
    datosAlarmados
    datosSilenciados
    entradas {
      uuid
      alarmado
      silenciado
      lastFecha
      lastValor
      tiene {
        uuid
        nombre
      }
      entradasConnection {
        edges {
          lastFecha
          node {
            uuid
            nombre
          }
        }
      }
    }
  }
}`



// Nodos con datos alarmados a ambos niveles :
export const getNodeAlarmsDetail = gql`
query getNodeAlarmsDetail($uuid: [String]) {
  getNodeAlarmsDetail(uuid: $uuid) {
    fecha
    properties {
      alarmado
      id_tipo_medicion_dispositivo
      lastFecha
      lastValor
      lastValor
    }
    type
  }
}
`


// alarmas de nodos a nivel dato:
export const silenceDato= gql`
mutation silenceDato($uuid: String) {
  silenceDato(uuid: $uuid) {
    uuid
    silenciado
    alarmado
  }
}
`

// alarmas de nodos a nivel dato:
export const rearmarDato= gql`
mutation rearmarDato($uuid: String) {
  rearmarDato(uuid: $uuid) {
    uuid
    silenciado
    alarmado
  }
}
`

// alarmas de nodos a nivel nodo:
export const silenceSource= gql`
mutation silenceSource($uuid: String) {
  silenceSource(uuid: $uuid) {
    uuid
    silenciado
    alarmado
  }
}
`

export const rearmarSource= gql`
mutation rearmarSource($uuid: String) {
  rearmarSource(uuid: $uuid) {
    uuid
    silenciado
    alarmado
  }
}
`

export const silenceNodeLink= gql`
mutation silenceNodeLink($uuid: String) {
  silenceNodeLink(uuid: $uuid) {
    uuid
    silenciado
    alarmado
  }
}
`


export const rearmarNodeLink= gql`
mutation rearmarNodeLink($uuid: String) {
  rearmarNodeLink(uuid: $uuid) {
    uuid
    silenciado
    alarmado
  }
}
`





